import React, { FC } from 'react'
import { PAYMENT_ITEMS, PAYMENT_TYPE } from '@/apps/Applications/consts'
import Radio from '@/components/Radio'
import styles from './style/index.module.scss'

interface IPaymentMethod {
  activeItem: PAYMENT_TYPE | null
  setActiveItem: React.Dispatch<React.SetStateAction<PAYMENT_TYPE | null>>
}

const PaymentMethod: FC<IPaymentMethod> = ({ activeItem, setActiveItem }) => {

  return (
    <div className={styles['actions']}>
      {PAYMENT_ITEMS.map((item) => {
        if (item.flag) {
          return (
            <Radio
              key={item.id}
              name='pay'
              className={styles['actions--item']}
              checked={activeItem === item.id}
              onClick={() => {
                setActiveItem(item.id)
              }}
            >
              {item.title}
            </Radio>
          )
        }
        return null
      })}
    </div>
  )
}

export default PaymentMethod
